import React, { useEffect, useRef } from "react"

const CookiePolicyScript: React.FC = () => {
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const script = document.createElement("script")
    script.type = "text/javascript"
    script.setAttribute("charset", "UTF-8")
    script.setAttribute("data-cookiescriptreport", "report")
    script.src = "//report.cookie-script.com/r/9133005a8b7ce4ac701e5f642d3912fd.js"
    script.async = true
    containerRef.current?.appendChild(script)

    return () => {
      if (containerRef.current?.contains(script)) {
        containerRef.current.removeChild(script)
      }
    }
  }, [])

  return <div ref={containerRef} />
}

export default CookiePolicyScript
